<script>
  export let url;
  export let altText;
  export let lazyLoad;

  // console.log(url)
</script>

<div class="map-wrapper">
  <img src="{ url }" alt="{altText}" class="static-map" loading="{lazyLoad == 'true' ? 'lazy' : ''}">
</div>